export default {
  analyticsColumnTypes: (state) => state.analyticsColumnTypes,
  analyticsColumnSubTypes: (state) => state.analyticsColumnSubTypes,
  analyticsPeriod: (state) => state.analyticsPeriod,
  analyticsFirstColumn: (state) => state.analyticsFirstColumn,
  analyticsData: (state) => state.analyticsData,
  analyticsChart: (state) => state.analyticsChart,
  analyticsTerritoryType: (state) => state.analyticsTerritoryType,
  analyticsTerritoriesList: (state, getters) => {
    if(!getters.analyticsTerritoryType) {
      return []
    }
    if(getters.analyticsTerritoryType.id === 'sep_territories') {
      return getters.separatedTerritories || []
    }

    const type = getters.analyticsTerritoryType.id.split('-')

    if(type[0] === 'adm_territories') {
      return getters.admTerritories ? getters.admTerritories.filter(v => v.adm_level === parseInt(type[1])) : []
    }

    if(type[0] === 'zone_groups') {
      let zones = getters.zones ? getters.zones.filter(v => v.group === parseInt(type[1])) : []
      if(zones.length > 0) {
        return zones.map(v => {
          let coordinates = []
          v.adm_territories.forEach(territoryId => {
            const admTerritory = getters.admTerritories.filter(territory => territory.id === territoryId)
            if (admTerritory[0] && admTerritory[0].boundary) {
              coordinates = coordinates.concat(admTerritory[0].boundary.coordinates)
            }
          })

          return {
            ...v,
            boundary: {
              type: 'MultiPolygon',
              coordinates: coordinates
            }
          }
        })
      }
    }
    return []
  }
};



// WEBPACK FOOTER //
// ./src/store/analytics/getters.js